import { addDoc, collection } from "firebase/firestore";
import { db } from "../../../firebase";
import HelperForMetaData from "../../../Helpers/HelperForMetaData";

const CreateTransport = async (TransportObject, uid, SchoolID) => {
  try {
    const TransportsCollection = collection(db, "Transports");

    const data = HelperForMetaData({
      ...TransportObject,
      uid: uid,
      SchoolID: SchoolID,
    });
    await addDoc(TransportsCollection, data);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default CreateTransport;
